import { defaultDateTimeFormatter, TableField } from "@/types/table-field";

const id: TableField = {
  key: "idResposta",
  label: "ID",
  tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const nome: TableField = {
  key: "nomeUsuario",
  label: "Usuário",
  tdClass: ["align-middle", "quebrarPorPalavra", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const ug: TableField = {
  key: "unidadeGestora",
  label: "Unidade Gestora",
  tdClass: ["align-middle", "quebrarPorPalavra", "text-left", "text-xl-center"],
  thClass: ["text-center", "quebrarPorPalavra"],
  thStyle: { minWidth: "110px" },
  sortable: true,
};
const data: TableField = {
  key: "dataResposta",
  label: "Data",
  tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  formatter: defaultDateTimeFormatter,
  sortable: true,
};
const details: TableField = {
  key: "show_details",
  label: "Detalhes",
  tdClass: ["align-middle", "col-actions", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  thStyle: { minWidth: "80px" },
  sortable: false,
};

export const fieldsRespostas: TableField[] = [id, nome, ug, data, details];
